export default __webpack_public_path__ + "static/media/healthcare.ac2c2a1f.gif";